import { Chip } from '@mui/material';
import { alpha, Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import React from 'react';

export type StatusTone = 'error' | 'warning' | 'success' | 'info' | 'neutral';

const useStyles = makeStyles((theme: Theme) => {
  const isDark = theme.palette.mode === 'dark';
  const errorText = isDark ? theme.palette.error.light : theme.palette.error.dark;
  const infoText = isDark ? theme.palette.info.light : theme.palette.info.dark;

  return createStyles({
    chip: {
      flexShrink: 0,
      fontSize: theme.typography.caption.fontSize,
    },
    error: {
      color: errorText,
      borderColor: errorText,
    },
    warning: {
      color: theme.palette.text.primary,
      borderColor: theme.palette.warning.dark,
      backgroundColor: alpha(theme.palette.warning.light, 0.24),
    },
    success: {
      color: theme.palette.success.dark,
      borderColor: theme.palette.success.dark,
    },
    info: {
      color: infoText,
      borderColor: infoText,
    },
    neutral: {
      color: theme.palette.tab.offselected,
      borderColor: theme.palette.tab.offselected,
    },
  });
});

type StatusChipProps = {
  label: string;
  tone: StatusTone;
};

export const StatusChip = ({ label, tone }: StatusChipProps) => {
  const classes = useStyles();

  return (
    <Chip
      size="small"
      variant="outlined"
      label={label}
      className={`${classes.chip} ${classes[tone]}`}
    />
  );
};
